module.exports = __webpack_public_path__ + "4cabad8ce1c5c96d66fa292dd9e7735b.svg";